import type { TFunction } from 'i18next';

import EyeFill from '@/assets/icons/eye_fill.svg?component';
import HourglassFill from '@/assets/icons/hourglass_fill.svg?component';
import MailLine from '@/assets/icons/mail_line.svg?component';
import VideoPlayFill from '@/assets/icons/video_play_fill.svg?component';
import { Alert } from '@/components/atoms/Alert';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { LoadingBarWithBanner } from '@/components/molecules/LoadingBarWithBanner';
import videoStreamImage from '@/svg/vidoe-stream.jpg';

import styles from '../LocationVideo.module.scss';

interface BannerProps {
    t: TFunction;
}

/** The empty video grid: what live video is and how to get it. */
export function Hello({ t }: BannerProps) {
    return (
        <div className={styles.videoGridEmpty}>
            <img src={videoStreamImage} alt="" />
            <div className={styles.textContainer}>
                <div className={styles.headerContainer}>
                    <SvgIcon
                        icon={VideoPlayFill}
                        size="custom"
                        customSize={30}
                        color="var(--color-success-fill)"
                    />
                    <h2>{t('location.video.liveVideoSecionTitle')}</h2>
                </div>
                <p>
                    {t('location.video.liveVideSecionPart1')}{' '}
                    <b>{t('location.video.liveVideSecionPart2')}</b>{' '}
                    {t('location.video.liveVideSecionPart3')}
                </p>
                <p>
                    {t('location.video.liveVideSecionPart4')}{' '}
                    <b>{t('location.video.liveVideSecionPart5')}</b>{' '}
                    {t('location.video.liveVideSecionPart6')}
                </p>
                <p>
                    <b>{t('location.video.liveVideSecionPart7')}</b>{' '}
                    {t('location.video.liveVideSecionPart8')}
                </p>
                <p className={styles.contactMsg}>
                    <SvgIcon icon={MailLine} size="custom" customSize={20} />
                    {t('location.video.liveVideSecionPart9')}{' '}
                    <a href="mailto:support@optoscale.no">
                        {t('location.video.liveVideSecionPart10')}
                    </a>{' '}
                    {t('location.video.liveVideSecionPart11')}
                </p>
            </div>
        </div>
    );
}

/** Shown instead of the chips while another user streams: this user can watch but not steer. */
export function Viewmode({ t }: BannerProps) {
    return (
        <div className={styles.videoLoadingTopBaner}>
            <Alert
                tone="neutral"
                icon={<SvgIcon icon={EyeFill} color="var(--color-success-fill)" />}
                title={t('location.video.viewMode')}>
                {t('location.video.viewModeDescription')}
            </Alert>
        </div>
    );
}

export function StreamLoadingBanner({ t }: BannerProps) {
    return (
        <div className={styles.videoLoadingTopBaner}>
            <LoadingBarWithBanner showLoadingBar={true}>
                <div className={styles.addPadding}>
                    <div className={styles.videoLoadingTextWithIcon}>
                        <SvgIcon icon={HourglassFill} color="var(--color-success-fill)" />
                        <h5>{t('location.video.loadingLiveStream')}</h5>
                    </div>
                    <div className={styles.contentWrapper}>
                        {t('location.video.loadingTextDescription')}
                    </div>
                </div>
            </LoadingBarWithBanner>
        </div>
    );
}
